<template>
    <div class="wrapper" >
        <div class="scroller">
            <div class="row bottom_line" v-for="(item, index) in rows" :ref="'item'+index" :key="index">
                <div class="help_line_container">
                    <span class="help_first_style">问:</span>
                    <span class="help_second_style">{{item.Q}}</span>
                </div>
                <div class="help_line_container margin_top_8">
                    <span class="help_first_style">答:</span>
                    <span class="help_second_style">{{item.A}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .wrapper {
        align-items: center;
        flex: 1;
    }

    .scroller {
        width: 750px;
        background-color: #ffffff;
    }

    .bottom_line {
        border-bottom-style: solid;
        border-bottom-width: 2px;
        border-bottom-color: #EAEAEA;
    }

    .margin_top_8 {
        margin-top: 8px;
    }

    .row {
        /* padding-left: 40px;
        padding-right: 40px; */
        padding-top: 36px;
        padding-bottom: 36px;
        width: 750px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .help_first_style {
        height: 40px;
        font-size: 28px;
        line-height: 36px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 135, 255, 1);
        margin-right: 10px;
    }

    .help_second_style {
        font-size: 28px;
        line-height: 36px;
        width: 620px;
        display: flex;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }

    .help_line_container {
        width: 750px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        flex-wrap: wrap;
    }

    .text {
        font-size: 45px;
        color: #666666;
    }
</style>

<script>
    export default {
        components: {
        },
        data: function() {
            return {
                rows: [
                    {
                        Q:"为什么我的项目无法开具电子发票？",
                        A:"电子发票需要项目运营方申请开通，请您联系项目物业部门。"
                    },{
                        Q:"会议室订单支付成功，为什么开票页面查询不到相关订单记录？",
                        A:"会议室使用完毕才能开票。"
                    },{
                        Q:"我已正确填写电子邮箱，为什么无法获取电子发票？",
                        A:"请您联系项目物业部门。"
                    },{
                        Q:"收到的发票为什么无法在税务局查到？",
                        A:"发票数据从企业上传到税务局可能出现短暂的延迟，请稍后再尝试查询。"
                    },{
                        Q:"我填错了发票抬头信息需要修改，应该怎么处理？",
                        A:"成功开具电子发票后，需要修改发票抬头或有其他疑问，请咨询园区工作人员。"
                    }
                ]
            };
        },
        created() {
        },
        methods: {
        }
    }
</script>